import React from "react";
import { AddressFieldSets, FormSectionElements } from "../../entities/formTemplateDataType";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import PlacesAutoComplete from "../../designComponent/subComponent/PlaceAutoComponent";
import { getRootComponent } from "../../utilities/ElementUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
  touched: boolean

}
export class GoogleLookUpAddressComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    this.state = {

      touched: false,

    };
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  onTextEditChange = (e) => {
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    this.props.field.Valid = Utils.isNotNullOrEmpty(val);
    this.props.field.Value = val;
    this.props.callbackElement(getRootComponent(this.props.field));
  }

  handlePlaceSelected = (place) => {
    console.log(place);
  }

  render() {
    console.log("this.props.field.Value",this.props.field.Value);
    let controlArray = [];

    let field = this.props.field;

    if (!field.Value) {
      field.Value = new AddressFieldSets();
    }

    if (this.props.editable) {

      <LiveValidationErrMsg
      field={this.props.field}
     isEng={this.props.isEng}
     key={"LiveValidationErrMsg_" +this.props.field.LoadBindName} />


      controlArray.push(
        <PlacesAutoComplete
          onPlaceSelected={this.handlePlaceSelected}
          field={field}
          callback={
            (value: AddressFieldSets) => {
              console.log(value);
              field.Value = value;
            }
          }
        />
      )
    } else {
      controlArray.push(
        <PlacesAutoComplete
          onPlaceSelected={this.handlePlaceSelected}
          field={field}
          review={true}
          callback={
            (value: AddressFieldSets) => {
              console.log(value);
              field.Value = value;
            }
          }
        />
      )
    }

    return controlArray;
  }
}